<ng-container
  *ngIf="{
    customer: customer$ | async,
    currentAccount: currentAccount$ | async,
    customerInvestment: customerInvestment$ | async,
    hasInvestDetailsFlag: hasInvestDetailsFlag$ | async
  } as vm"
>
  <h1 class="ui-headline">{{ 'nav.adjust-investment' | translate }}</h1>

  <nav class="fund-tabs" [class.fund-tabs-center]="!showSpTab">
    <a *ngIf="showSpTab" class="fund-tab" (click)="onSwitchTab(tabs.SavingsPlan)" [class.active]="activeTab === tabs.SavingsPlan">
      <div class="icon-holder">
        <span class="icon-i-deposit"></span>
      </div>
      <h4>{{ 'sp.revamp.nav.sp.title' | translate }}</h4>
    </a>

    <a class="fund-tab" (click)="onSwitchTab(tabs.Withdrawal)" [class.active]="activeTab === tabs.Withdrawal">
      <div class="icon-holder">
        <span class="icon-i-withdrawal"></span>
      </div>
      <h4>{{ 'sp.revamp.nav.withdrawal.title' | translate }}</h4>
    </a>

    <a class="fund-tab" (click)="onSwitchTab(tabs.AccountDetails)" [class.active]="activeTab === tabs.AccountDetails">
      <div class="icon-holder">
        <span class="icon-i-bank"></span>
      </div>
      <h4>{{ 'sp.revamp.nav.accountDetails.title' | translate }}</h4>
    </a>
  </nav>

  <div class="fund-tabs-content">
    <ng-container *ngIf="activeTab === tabs.SavingsPlan">
      <div class="savings-plan">
        <ng-container *ngIf="vm.currentAccount?.kind !== '3a'; else account3a">
          <app-savings-analysis
            [customer]="vm.customer"
            [customerInvestment]="vm.customerInvestment"
            [currentAccount]="vm.currentAccount"
            (changeTab)="onSwitchTab($event)"
          ></app-savings-analysis>
        </ng-container>
        <ng-template #account3a>
          <app-savings-analysis-3a
            [customer]="vm.customer"
            [customerInvestment]="vm.customerInvestment"
            [currentAccount]="vm.currentAccount"
            [contributionLevel]="vm.currentAccount?.max_contribution_level"
            (changeTab)="onSwitchTab($event)"
          ></app-savings-analysis-3a>
        </ng-template>
      </div>

      <div class="savings-reasons" #reasonsEl>
        <div class="savings-reasons-header">
          <div class="icon-holder">
            <span class="icon-i-lamp"></span>
          </div>
          <h2 class="ui-headline">{{ 'sp.revamp.reasons.title' | translate }}</h2>
        </div>

        <div *ngFor="let reason of [1, 2, 3]" class="savings-reason">
          <p>
            <span><img [src]="'assets/images/reminder/reason' + reason + '.svg'" alt="Reason Icon" /></span>
            <strong>{{ 'sp.revamp.reasons.reason' + reason + '.title' | translate }}</strong>
          </p>
          <p>{{ 'sp.revamp.reasons.reason' + reason + '.description' | translate }}</p>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="activeTab === tabs.Withdrawal">
      <ng-container *ngIf="vm.currentAccount.kind === '3a'; else showNewWithdrawal">
        <app-withdrawal-3a [currentAccount]="vm.currentAccount"></app-withdrawal-3a>
      </ng-container>
      <ng-template #showNewWithdrawal>
        <div class="ds-card withdrawal-card">
          <div class="ds-card-content">
            <app-withdrawal
              [accountInvested]="accountInvested$ | async"
              [withdrawalAllocation]="withdrawalAllocation$ | async"
              [customer]="vm.customer"
              [currentAccount]="vm.currentAccount"
              [hasWithdrawalPromotion]="hasWithdrawalPromotion$ | async"
              [isMobileApp]="environment.productType === 'mobile-app'"
              (reFetchPromotions)="onReFetchPromotions()"
              (getWithdrawalData)="onGetWithdrawalData()"
              (showToastError)="onShowToastError($event)"
              (trackActivity)="onTrackActivity($event)"
              (scrollToTop)="onScrollToTop()"
            ></app-withdrawal>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <ng-container *ngIf="activeTab === tabs.AccountDetails">
      @if (vm.hasInvestDetailsFlag) {
        <app-fund-invest-details
          [appLocation]="vm.customer.app_location"
          [currentAccount]="vm.currentAccount"
          [ownerName]="vm.customer.first_name + ' ' + vm.customer.last_name"
          [financialDetails]="financialDetails"
          [transfer3ADoc]="transfer3ADoc$ | async"
          (fetchFinancialSituation)="onGetFinancialSituation()"
          (getTransfer3ADoc)="onGetTransfer3ADoc()"
        >
        </app-fund-invest-details>
      } @else {
        <app-fund-account-details
          [customer]="vm.customer"
          [currentAccount]="vm.currentAccount"
          [financialDetails]="financialDetails"
          (contactSupport)="onContactSupport()"
          (getFinancialSituation)="onGetFinancialSituation()"
          (trackActivity)="onTrackActivity($event)"
        ></app-fund-account-details>
      }
    </ng-container>
  </div>
</ng-container>
